export default {
      id: "icon--sledging-usage",
      viewBox: "0 0 28 15",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--sledging-usage",
      toString: function () {
        return this.url;
      }
    }